/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Frontend SPA Contract API
 * Canonical API contract entrypoint.
 *
 * Source architecture:
 * - split by module / bounded context
 * - one file per aggregate root
 * - child entities remain owned by aggregate root
 * - cross-cutting technical concerns live under `openapi/common`
 *
 * OpenAPI spec version: 1.0.0
 */
import * as zod from "zod";
import {PaginationMeta2} from "./paginationMeta2.zod";
import {RepresentativeDto} from "./representativeDto.zod";

export const PaginatedRepresentativeDto = zod.object({
  items: zod.array(RepresentativeDto),
  meta: PaginationMeta2,
});

export type PaginatedRepresentativeDto = zod.input<typeof PaginatedRepresentativeDto>;
export type PaginatedRepresentativeDtoOutput = zod.output<typeof PaginatedRepresentativeDto>;
